import { callGetApi, callPostApi } from "@/utils/apiWrapper";
import {
  requestSherlockAuthLogin,
  requestSherlockAuthRegister,
} from "@/utils/authApi";
import { bindSalesAttribution } from "@/utils/salesAttribution";

const SHERLOCK_AUTH_API = {
  CHECK_ID: "/api/v1/sherlock/auth/check-id", // + /:loginId
  SMS_SEND: "/api/v1/sherlock/auth/sms/send",
  SMS_VERIFY: "/api/v1/sherlock/auth/sms/verify",
  FIND_ID: "/api/v1/sherlock/auth/find-id",
  RESET_PASSWORD: "/api/v1/sherlock/auth/reset-password",
};

export const state = {};

export const mutations = {};

export const actions = {
  /**
   * 셜록 아이디/비밀번호 로그인
   */
  async acSherlockLogin(_, { loginId, password }) {
    let res = null;
    try {
      const response = await requestSherlockAuthLogin({ loginId, password });
      res = response?.data?.code === 0 ? response.data?.data ?? true : null;
    } catch (error) {
      res = null;
    }
    if (res && res.access_token) {
      window.localStorage.setItem("naezip_to_ac_se", res.access_token);
      void bindSalesAttribution(res.access_token);
      // refresh_token은 http-only 쿠키로 전달됨 (카카오 로그인과 동일).
    }
    return res;
  },

  /**
   * 아이디 중복 확인
   */
  async acSherlockCheckId({ commit }, loginId) {
    const res = await callGetApi({
      url: `${SHERLOCK_AUTH_API.CHECK_ID}/${loginId}`,
      params: {},
      commit,
    });
    return res;
  },

  /**
   * SMS 인증번호 발송
   */
  async acSherlockSmsSend({ commit }, { mobile, purpose }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.SMS_SEND,
      data: { mobile, purpose },
      commit,
    });
    return res;
  },

  /**
   * SMS 인증번호 확인
   */
  async acSherlockSmsVerify({ commit }, { mobile, code, purpose }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.SMS_VERIFY,
      data: { mobile, code, purpose },
      commit,
    });
    return res;
  },

  /**
   * 회원가입
   */
  async acSherlockRegister(_, payload) {
    try {
      const response = await requestSherlockAuthRegister(payload);
      return response?.data?.code === 0 ? response.data?.data ?? true : null;
    } catch (error) {
      return null;
    }
  },

  /**
   * 아이디 찾기
   */
  async acSherlockFindId({ commit }, { name, mobile }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.FIND_ID,
      data: { name, mobile },
      commit,
    });
    return res;
  },

  /**
   * 비밀번호 재설정
   */
  async acSherlockResetPassword({ commit }, { name, mobile, newPassword }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.RESET_PASSWORD,
      data: { name, mobile, newPassword },
      commit,
    });
    return res;
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
